"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItemReport = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _api = require("../../api");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _components2 = require("./components");
var _EmailInput = require("./components/EmailInput");
var _ReasonInput = require("./components/ReasonInput");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DetailItemReport = ({
  reportPhotoUrl,
  onClose
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const form = (0, _reactHookForm.useForm)({
    mode: 'onSubmit',
    defaultValues: {
      email: '',
      reason: ''
    },
    resolver: (0, _zod.zodResolver)(_constants.reportItemValidationSchema)
  });
  const {
    reportStatus,
    report
  } = (0, _api.useReportItem)();
  const onSubmit = (0, _react.useCallback)(async ({
    email,
    reason
  }) => {
    await report({
      email,
      reason,
      url: reportPhotoUrl
    });
  }, [report, reportPhotoUrl]);
  const renderReportStatus = (0, _react.useMemo)(() => {
    switch (reportStatus) {
      case _models.ReportStatus.new:
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailInput.EmailInput, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReasonInput.ReasonInput, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            fullWidth: true,
            variant: "contained",
            color: "error",
            "data-testid": getTestId(_constants.REPORT_SUBMIT),
            type: "submit",
            children: translations.olapic2Report
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.ReportCancelButton, {
            onClose: onClose
          })]
        });
      case _models.ReportStatus.sending:
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Loading, {
            size: 48
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.ReportCancelButton, {
            onClose: onClose
          })]
        });
      case _models.ReportStatus.sent:
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextPart, {
            align: "center",
            color: "textPrimary",
            children: translations.olapic2ReportSuccess
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.ReportCancelButton, {
            onClose: onClose
          })]
        });
      case _models.ReportStatus.error:
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextPart, {
            align: "center",
            color: "textPrimary",
            children: translations.olapic2ReportFailed
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.ReportCancelButton, {
            onClose: onClose
          })]
        });
      default:
        return null;
    }
  }, [reportStatus, getTestId, translations, onClose]);
  if (!renderReportStatus) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
    ...form,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
      noValidate: true,
      onSubmit: form.handleSubmit(onSubmit),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailItemReportRoot, {
        "data-testid": getTestId(_constants.REPORT),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          component: "h3",
          align: "center",
          color: "textPrimary",
          children: translations.reportPhoto
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextPart, {
          align: "left",
          children: translations.olapic2ReportPhotoExplanation
        }), renderReportStatus]
      })
    })
  });
};
exports.DetailItemReport = DetailItemReport;
